import React, {useState} from 'react';
import Slider from "react-slick";

const CollectionsSlider = (props) => {
    const {
        collections,
        AllProductsTitle,
        scrollToCollection
    } = props;

    const settings = {
        infinite: true,
        arrows: true
    }

    return (
        <div className="collections-list">
            <h2 className="all-products-title">{AllProductsTitle.Value}</h2>
            <Slider
                className="collections-slider"
                {...settings}
            >
                {collections.map((collection) => (
                    <div className="collection-item">
                        <a href={"#" + collection.Id} onClick={(e) => scrollToCollection(e, collection.Id)}>{collection.Title.Value}</a>
                    </div>
                ))}
            </Slider>
        </div>
    );
}
export default CollectionsSlider;
